import './antd/App.less'
import React from 'react'
import Router from './routes/Router'
import './App.css';
import { notification } from 'antd'
import { LicenseInfo, ptBR } from '@mui/x-data-grid-pro'
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import { ptBR as coreptBR } from '@material-ui/core/locale';
import GeneralContextProvider from './context/GeneralContext/GeneralContextProvider';
import { displayMessage } from './services/helper';

const theme = createTheme(
  { palette: { primary: { main: '#1976d2' }, }, },
  ptBR,
  coreptBR,
)

LicenseInfo.setLicenseKey(
  '1ef6d6c91f74abe50c0b422b86df9bdaT1JERVI6Mjk3NTksRVhQSVJZPTE2NjM4NzA5MzYwMDAsS0VZVkVSU0lPTj0x',
)

document.querySelectorAll("ant-select-dropdown").forEach(function (element) {
  element.style.zIndex = "9999";
  element.style.width = "8888px";
});



window.alert = (message, type = 'info', title = `${displayMessage('ATENTION')}!`, duration = 3, key = 'unique') => {
  notification[type]({
    key,
    message: title,
    description: message,
    placement: 'topRight',
    duration
  })
}



function App() {


  return (
    <ThemeProvider theme={theme}>
      <GeneralContextProvider>
        <Router />
      </GeneralContextProvider>
    </ThemeProvider>
  )
}

export default App;
